// extracted by mini-css-extract-plugin
module.exports = {"selectedOffer":"_1vQFF5ce9tp2poGSEazdw8"};